import { render, staticRenderFns } from "./comType.vue?vue&type=template&id=7a2876a7&scoped=true"
import script from "./comType.vue?vue&type=script&lang=js"
export * from "./comType.vue?vue&type=script&lang=js"
import style0 from "./comType.vue?vue&type=style&index=0&id=7a2876a7&prod&lang=scss&scoped=true"
import style1 from "./comType.vue?vue&type=style&index=1&id=7a2876a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2876a7",
  null
  
)

export default component.exports